import {
  postDedicationGuest,
  deleteDedicationGuest,
  deleteDedicationAdmin
} from "../../../helpers/event_helper.js";
import { dedicationSaving, dedicationSuccess, dedicationError } from "./reducer";

// 422 validation errors arrive as a violations array, everything else as a string.
const errorMessage = (error) => (Array.isArray(error) ? error[0]?.message : error);

export const addDedication = (payload) => async (dispatch) => {
  try {
    dispatch(dedicationSaving());
    const data = await postDedicationGuest(payload);
    if (data) {
      dispatch(dedicationSuccess());
    }
  } catch (error) {
    dispatch(dedicationError(errorMessage(error)));
  }
};

// No guestId means the host is clearing somebody's dedication off the list.
export const deleteDedication = (id, guestId) => async (dispatch) => {
  try {
    dispatch(dedicationSaving());
    guestId
      ? await deleteDedicationGuest(id, { id: guestId })
      : await deleteDedicationAdmin(id);
    dispatch(dedicationSuccess());
  } catch (error) {
    dispatch(dedicationError(errorMessage(error)));
  }
};
